var map = {
	"./ACGIH-Heavy": 437,
	"./ACGIH-Heavy.json": 437,
	"./ACGIH-Light": 438,
	"./ACGIH-Light.json": 438,
	"./ACGIH-Moderate": 439,
	"./ACGIH-Moderate.json": 439,
	"./ACSM-Acclimatized": 440,
	"./ACSM-Acclimatized.json": 440,
	"./ACSM-NonAcclimatized": 441,
	"./ACSM-NonAcclimatized.json": 441,
	"./GaStateHighSchool": 442,
	"./GaStateHighSchool.json": 442,
	"./KyStateHighSchool": 443,
	"./KyStateHighSchool.json": 443,
	"./NATA": 444,
	"./NATA.json": 444,
	"./NcStateHighSchool": 445,
	"./NcStateHighSchool.json": 445,
	"./NjStateHighSchool": 446,
	"./NjStateHighSchool.json": 446,
	"./TBMed507-Easy": 447,
	"./TBMed507-Easy.json": 447,
	"./TBMed507-Hard": 448,
	"./TBMed507-Hard.json": 448,
	"./TBMed507-Moderate": 449,
	"./TBMed507-Moderate.json": 449,
	"./UsaSoccer-Cat1": 450,
	"./UsaSoccer-Cat1.json": 450,
	"./UsaSoccer-Cat2": 451,
	"./UsaSoccer-Cat2.json": 451,
	"./UsaSoccer-Cat3": 452,
	"./UsaSoccer-Cat3.json": 452,
	"./VtStateHighSchool": 453,
	"./VtStateHighSchool.json": 453,
	"./_HeatStressGuidelinesIndex": 351,
	"./_HeatStressGuidelinesIndex.json": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 673;